import { useEffect } from 'react';
import { pick } from 'ramda';
import { dispatcher } from 'dispatcher';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';
import { usePrevious } from 'js/hooks/usePrevious';

export const trackGamesMount = (container, gameFeed) =>
    dispatcher.dispatch('games:mount', { container, gameFeed });

export const trackGameCategoryExpand = (container, gameFeed, categoryName) =>
    dispatcher.dispatch('game:category:expand', { container, gameFeed, categoryName });

export const trackGameCategorySwitch = (container, gameFeed, categoryName) =>
    dispatcher.dispatch('game:category:switch', { container, gameFeed, categoryName });

export const trackGameCategoryActiveSlideChange = (container, gameFeed, categoryName, elementClicked) =>
    dispatcher.dispatch('game:category:activeSlide:change', {
        container, gameFeed, categoryName, elementClicked
    });

export const trackJackpotVisibility = visibleEntries =>
    dispatcher.dispatch('jackpot:visibility', visibleEntries);

export const trackGameSearchChange = (container, gameFeed, searchString) =>
    dispatcher.dispatch('game:search:change', { container, gameFeed, searchString });

export const trackGamesPersonalizedGrid2 = (
    container,
    gameFeed,
    personalizedCategoryName,
    personalizedGridFallback
) => dispatcher.dispatch(
    'games:personalizedGrid:2',
    {
        container,
        gameFeed,
        personalizedCategoryName,
        personalizedGridFallback,
        pagePath: window.location.pathname
    }
);

// helpers

export const useTracking = () => {
    const { reactPortletId } = usePortletConfig();
    const { feedName, categories, expandedCategory } = usePortletSelector(pick([
        'feedName',
        'categories',
        'expandedCategory'
    ]));

    useEffect(() => {
        if (reactPortletId && feedName) {
            // this should be called once with relevant parameters. Might not be the best solution.
            trackGamesMount(reactPortletId, feedName);
        }
    }, [reactPortletId, feedName]);

    const prevExpanded = usePrevious(expandedCategory);
    useEffect(() => {
        if (expandedCategory && expandedCategory !== prevExpanded) {
            const categoryName = categories.find(cat => cat.cid === expandedCategory).name;

            trackGameCategoryExpand(reactPortletId, feedName, categoryName);
        }
    }, [expandedCategory, prevExpanded, feedName, categories, reactPortletId]);
};
